export default {"src":"/_next/static/media/Component 1.c9ede505.svg","height":460,"width":450,"blurWidth":0,"blurHeight":0};